import React, {Component} from 'react';
import {Grid} from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import {Helmet} from "react-helmet";
import * as api from "../../api";
import HHTableHeader from "./hh-table-header";
import HHTableRow from "./hh-table-row";
import {DateFilter} from "../../components/table/filters/date-filter";
import FilterableDatatable from "../../components/table/filterable-data-table";
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";
import MonthlyUnitLineChart from '../../components/charts/custom/monthly-unit-line-chart';
import ReactGA from 'react-ga';
import { BreadcrumbContext } from '../../components/header/breadcrumbcontext'; // Adjust the path as necessary

export default class HalfHour extends Component {
    static contextType = BreadcrumbContext;

    constructor(props) {
        super(props);
        this.state = {
            dataProvider: new ApiDataProvider(api.getHalfHourReadings, [this.props.customerId]),
        }
    }

    componentDidMount = () => {
       
        ReactGA.pageview(window.location.pathname);
        this.context.addBreadcrumb({ title: "Half Hour Data" , path: '/hh' });

    };

    render() {
        return (
            <div className="main-container">
                <Helmet>
                    <title>Inenco Portal | Half-Hour Data</title>
                </Helmet>
                <Grid padded stackable columns='equal' verticalAlign='middle'>
                    <Grid.Row>
                        <Grid.Column>
                            <h2>Half-Hour Data</h2>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                        { this.state.chartData && this.state.chartData.length > 0 &&
                            <MonthlyUnitLineChart data={this.state.chartData} dateFormat="Do MMM YY"
                                                  units={this.state.chartUnits}
                                                  title={`${this.state.currentFilter.commodity} Price`}
                                                  isLoading={this.state.isLoading}
                                                  size="medium"
                                                  label={this.getCommodityLabel()}/>
                            }
                            
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <div className="table-container">
                                <FilterableDatatable dataProvider={this.state.dataProvider} canExport={true}
                                                     filterComponent={DateFilter} defaultSort={"date"} name="half-hour"
                                                     headerComponent={HHTableHeader} rowComponent={HHTableRow}
                                                     contextData={{ customerId: this.props.customerId }} />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}